<template>
  <app-popup :active.sync="isActive" title="Ошибки начисления">
    <div v-for="(error, index) in errors" :key="`error-${index}`" class="employee-accruals-error-row">
      <div class="employee-accruals-error-row__index">{{index + 1 }}</div>
      <div class="employee-accruals-error-row__text">{{error}}</div>
    </div>
  </app-popup>
</template>

<script>
  export default {
    name: "ErrorsPopup",
    data(){
      return {
        isActive: false,
        errors: [],
      }
    },
    methods: {
      open(errors){
        this.errors = errors;
        this.isActive = true;
      }
    }
  }
</script>

<style lang="scss">
  .employee-accruals-error-row{
    display: flex;
    align-items: flex-start;
    line-height: 1.2;
    margin-bottom: 10px;

    &__index{
      display: flex;
      flex-shrink: 0;
      width: 20px;
      margin-right: 10px;
      font-weight: 500;
    }

  }
</style>
